import { css } from "styled-components";

export type StickyStyle = {
  sticky?: {
    top?: number;
    bottom?: number;
    left?: number;
    right?: number;
  };
};

export const stickyStyle = ({ sticky }: StickyStyle) =>
  !!sticky &&
  css`
    position: sticky;
    position: -webkit-sticky;
    top: ${sticky?.top}px;
    bottom: ${sticky?.bottom}px;
    left: ${sticky?.left}px;
    right: ${sticky?.right}px;
  `;
